const Checkbox = {
  defaultProps: {
    colorScheme: 'primaryScale',
    label: {
      borderColor: 'primaryScale.600',
      background: 'primaryScale.100',
      borderRadius: '4px',
      _focus: {
        boxShadow: 'focus'
      }
    },

    size: 'md'
  },
  sizes: {
    md: {
      h: '18px',
      w: '18px',
      borderRadius: '4px'
    }
  }
};

export default Checkbox;
